import { Directive, HostListener } from '@angular/core';

@Directive({ selector: '[emojiPickerCloser]' })
export class EmojiPickerCloser {

  @HostListener('document:click', ['$event'])
  onDocumentClick(
    $event
  ) {

    if (!this.emojiPickerExists) {
      return;
    }

    const clickOriginatedFromEmojiPicker =
      this.isDescendantOfClass($event.target, 'ql-emoji') ||
      this.isDescendantOfId($event.target, 'emoji-palette') ||
      $event.target.id === 'emoji-close-div';

    if (!clickOriginatedFromEmojiPicker) {
      this.closeEmojiPicker();
    }
  }

  private get emojiPicker(): HTMLDivElement | null {
    return document.querySelector<HTMLDivElement>('#emoji-palette');
  }

  private get emojiPickerExists(): boolean {
    return !!this.emojiPicker;
  }

  private closeEmojiPicker(): void {
    this.emojiPicker && this.emojiPicker.remove();
  }

  private isDescendantOfClass(
    element: Element,
    containerClass: string
  ): boolean {

    while (element = element.parentElement) {

      if (element.classList.contains(containerClass)) {
        return true;
      }
    }

    return false;
  }

  private isDescendantOfId(
    element: Element,
    containerId: string
  ): boolean {

    while (element = element.parentElement) {

      if (element.id === containerId) {
        return true;
      }
    }

    return false;
  }

}
